import { createSelector } from '@reduxjs/toolkit';
import { eventsAdapter } from '~SpectateStore/slices/eventsSlice';

export const {
    selectById: selectEventById,
    selectIds: selectEventIds,
    selectAll: selectAllEvents,
    selectEntities: selectAllEventsEntities,
} = eventsAdapter.getSelectors(state => state.events);

export const selectEventSportId = (state, eventId) => selectEventById(state, eventId)?.sport_id ?? null;
export const selectEventCategoryId = (state, eventId) => selectEventById(state, eventId)?.category_id ?? null;
export const selectEventTournamentId = (state, eventId) => selectEventById(state, eventId)?.tournament_id ?? null;
export const selectIsInplay = (state, eventId) => selectEventById(state, eventId)?.inplay;
export const selectHomeCompetitor = (state, eventId) => selectEventById(state, eventId)?.competitors?.home ?? { name: null };
export const selectAwayCompetitor = (state, eventId) => selectEventById(state, eventId)?.competitors?.away ?? { name: null };
export const selectIsStreamingAvailable = (state, eventId) => selectEventById(state, eventId)?.isStreamingAvailable ?? false;
export const selectFixtureId = (state, eventId) => selectEventById(state, eventId)?.streamingFixtureId ?? 0;
export const selectVisualizationProvider = (state, eventId) => selectEventById(state, eventId)?.visualization_provider ?? null;
export const selectMatchStatus = (state, eventId) => selectEventById(state, eventId)?.match_status;
export const selectStartTime = (state, eventId) => selectEventById(state, eventId)?.scheduled_start_time ?? null;
export const selectEventName = (state, eventId) => selectEventById(state, eventId)?.name ?? null;
export const selectSelectedMarketTab = (state, eventId) => selectEventById(state, eventId)?.selected_tab ?? 'all-markets';

export const selectAwayTeamName = createSelector(
    selectAwayCompetitor,
    (away) => away.name
);

export const selectHomeTeamName = createSelector(
    selectHomeCompetitor,
    (home) => home.name
);

export const selectAwayTeamSlug = createSelector(
    selectAwayCompetitor,
    (away) => away.slug
);

export const selectHomeTeamSlug = createSelector(
    selectHomeCompetitor,
    (home) => home.slug
);

export const selectEventGtmAttribute = createSelector(
    selectEventName,
    (name) => {
        return name?.replace(/[^A-Za-z0-9-]+/gi, '-').toLowerCase();
    }
);

export const selectMarketGroupsByEventId = (state, eventId) => selectEventById(state, eventId)?.markets_groups ?? [];

export const selectCashoutAvailable = createSelector(
    selectSelectedMarketTab,
    selectEventById,
    (marketGroup, event) => {
        if (event.markets_groups.length > 0) {
            return event.markets_groups.find(group => group.slug === marketGroup)?.cashout_enabled;
        }

        return event?.cashout_enabled;
    }
);

